import React, { useContext } from 'react';
import style from './athlete-profile-lite.module.scss';
import { AppContext } from '../../App';
import { getTrans } from '../../Utils/translate';
import { ModalComparison } from '../Modal/comparison';
import TagManager from 'react-gtm-module';

const Image = ({ selected, list, config }) => {
  const context = useContext(AppContext);
  const {
    age,
    textMandatoryFact,
    textShortFact1,
    textShortFact2,
    textLongFact1,
    textLongFact2
  } = context.lang;
  const findStats = (fact) => {
    if (selected.career_stats) {
      const factStat = selected.career_stats.find((e) => e.stat_type === fact);
      return factStat;
    }
  };

  return (
    <>
      {selected.career_stats && (
        <>
          <div style={{ background: 'var(--cosmos-color-surface-solid-dark-lighter)' }}>
            <div className={`appRow mt-0 modest-width ${style.factMandatoryWrapper}`}>
              <div
                style={{
                  display: 'grid',
                  alignItems: 'center',
                  justifyItems: 'flex-start'
                }}>
                <span className={style.factHeadingText}>{getTrans(textMandatoryFact)}</span>
                <span className={style.athleteMandatoryText}>
                  {selected.career_stats &&
                    (
                      getTrans(findStats('mandatory_fact').key) ||
                      findStats('mandatory_fact').fact
                    )}
                </span>
              </div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginRight: '15px'
                }}>
                {selected.age && (
                  <>
                    <span className={style.athleteAge}>{getTrans(age) + ':'}&nbsp; </span>
                    <span className={style.athleteAge}>{selected && selected.age}</span>
                  </>
                )}
              </div>
            </div>
          </div>
          <div className='appRow modest-width'>
            {(!config.hasOwnProperty('showCompareButton') || config.showCompareButton) &&
              <div className={`${style.rowWrapper} ${style.rowWrapperCompare} ${style.borderBottom}`}>
                <ModalComparison
                  layout="compact"
                  athleteLeftId={selected.athlete_id}
                  list={list}
                  config={config}
                  onClick={() => {
                    const dataLayerArgs = {
                      dataLayer: {
                        event: 'rbVideoTracking',
                        eventCategory: 'video',
                        eventAction: 'sidebar',
                        eventLabel: `Compare Athlete`,
                        widgetType: `${config.type} - ${config.trackingTitle || config.navigationTitle
                          }`,
                        athleteProfile: `${selected.label}`
                      }
                    };
                    TagManager.dataLayer(dataLayerArgs);
                  }}
                />
              </div>
            }
            {findStats('short_fact_1') && findStats('short_fact_2') && (
              <>
                <div className={style.factWrapperTwo}>
                  <div style={{ display: 'grid' }}>
                    <span className={style.factHeadingText}>
                      {getTrans(textShortFact1)}
                    </span>
                    <span className={style.shortFactText1}>
                      {selected.career_stats &&
                        (
                          getTrans(findStats('short_fact_1').key) ||
                          findStats('short_fact_1').fact
                        )}
                    </span>
                  </div>
                  <div style={{ display: 'grid' }}>
                    <span className={style.factHeadingText}>
                      {getTrans(textShortFact2)}
                    </span>
                    <span className={style.shortFactText2}>
                      {selected.career_stats &&
                        (
                          getTrans(findStats('short_fact_2').key) ||
                          findStats('short_fact_2').fact
                        )}
                    </span>
                  </div>
                </div>
                <div
                  style={{
                    height: '1px',
                    width: '100%',
                    borderBottom: '1px solid rgba(255,255,255,0.2)'
                  }}></div>
              </>
            )}
            {findStats('short_fact_1') && !findStats('short_fact_2') && (
              <>
                <div className={style.factWrapper}>
                  <div style={{ display: 'grid' }}>
                    <span className={style.factHeadingText}>
                      {getTrans(textShortFact1)}
                    </span>
                    <span className={style.shortFactText1}>
                      {selected.career_stats &&
                        (
                          getTrans(findStats('short_fact_1').key) ||
                          findStats('short_fact_1').fact
                        )}
                    </span>
                  </div>
                </div>
                <div
                  style={{
                    height: '1px',
                    width: '100%',
                    borderBottom: '1px solid rgba(255,255,255,0.2)'
                  }}></div>
              </>
            )}
            {!findStats('short_fact_1') && findStats('short_fact_2') && (
              <>
                <div className={style.factWrapper}>
                  <div style={{ display: 'grid' }}>
                    <span className={style.factHeadingText}>
                      {getTrans(textShortFact2)}
                    </span>
                    <span className={style.shortFactText2}>
                      {selected.career_stats &&
                        (
                          getTrans(findStats('short_fact_2').key) ||
                          findStats('short_fact_2').fact
                        )}
                    </span>
                  </div>
                </div>
                <div
                  style={{
                    height: '1px',
                    width: '100%',
                    borderBottom: '1px solid rgba(255,255,255,0.2)'
                  }}
                ></div>
              </>
            )}
            {findStats('further_fact_1') && (
              <>
                <div
                  style={{
                    display: 'grid',
                    height: '80px',
                    alignItems: 'center',
                    padding: '15px'
                  }}>
                  <span className={style.factHeadingText}>{getTrans(textLongFact1)}</span>
                  <span className={style.longFactText}>
                    {selected.career_stats &&
                      (
                        getTrans(findStats('further_fact_1').key) ||
                        findStats('further_fact_1').fact
                      )}
                  </span>
                </div>
                <div
                  style={{
                    height: '1px',
                    width: '100%',
                    borderBottom: '1px solid rgba(255,255,255,0.2)'
                  }}></div>
              </>
            )}

            {findStats('further_fact_2') && (
              <>
                <div
                  style={{
                    display: 'grid',
                    height: '127px',
                    alignItems: 'center',
                    padding: '15px'
                  }}>
                  <span className={style.factHeadingText}>{getTrans(textLongFact2)}</span>
                  <span className={style.longFactText}>
                    {selected.career_stats &&
                      (
                        getTrans(findStats('further_fact_2').key) ||
                        findStats('further_fact_2').fact
                      )}
                  </span>
                </div>
                <div
                  style={{
                    height: '1px',
                    width: '100%',
                    borderBottom: '1px solid rgba(255,255,255,0.2)'
                  }}></div>
              </>
            )}
          </div>
        </>
      )}
    </>
  );
};

export { Image };
